// Gathering rules shared by the server, the web app and the phones
// (docs/gatherings.md, D282–D288). `now` is in milliseconds.
import { GATHERING_LIMITS } from './constants.js';
/** Cancelled, or 3 hours past the start (D286). */
export function gatheringEnded(state, now) {
    if (state.cancelledAt)
        return true;
    return (now >= Date.parse(state.startsAt) + GATHERING_LIMITS.OPEN_AFTER_START_MS);
}
export function isOpen(state, now) {
    return !gatheringEnded(state, now);
}
/** At most 2 rings, 3 minutes apart (D286). */
export function canRing(state, now) {
    if (gatheringEnded(state, now))
        return { ok: false, reason: 'ENDED' };
    if (!state.rings)
        return { ok: false, reason: 'RINGS_OFF' };
    if (state.ringsUsed >= GATHERING_LIMITS.MAX_RINGS)
        return { ok: false, reason: 'LIMIT' };
    if (state.lastRingAt &&
        now < Date.parse(state.lastRingAt) + GATHERING_LIMITS.RING_AGAIN_AFTER_MS) {
        return { ok: false, reason: 'TOO_SOON' };
    }
    return { ok: true };
}
const rowOf = (state, id) => state.replies.find((r) => r.userId === id);
/** Everyone but the ringer who has not said "not" and is not at the table yet. */
export function ringTargets(state, participantIds, ringerId) {
    return participantIds.filter((id) => {
        if (id === ringerId)
            return false;
        const row = rowOf(state, id);
        return !(row && (row.reply === 'not' || row.arrivedAt));
    });
}
/** The start-time reminder: Coming or unanswered; Late people get their own (D288). */
export function mainReminderTargets(state, participantIds) {
    return participantIds.filter((id) => {
        const row = rowOf(state, id);
        return !row || row.reply === 'coming';
    });
}
/** A Late person is reminded 10 minutes before the time they gave. */
export function lateReminderDue(row, startsAt, now) {
    if (row.reply !== 'late' || row.lateMinutes === null || row.arrivedAt)
        return false;
    return (now >=
        Date.parse(startsAt) +
            row.lateMinutes * 60_000 -
            GATHERING_LIMITS.REMINDER_BEFORE_MS);
}
export function replyCounts(state, participantIds) {
    const counts = { coming: 0, late: 0, not: 0, unanswered: 0, arrived: 0 };
    for (const id of participantIds) {
        const row = rowOf(state, id);
        if (!row)
            counts.unanswered++;
        else
            counts[row.reply]++;
        if (row?.arrivedAt)
            counts.arrived++;
    }
    return counts;
}
//# sourceMappingURL=gatherings.js.map